import { render, staticRenderFns } from "./pelletsverbrauch.vue?vue&type=template&id=b2d30ea6&scoped=true"
import script from "./pelletsverbrauch.vue?vue&type=script&lang=ts"
export * from "./pelletsverbrauch.vue?vue&type=script&lang=ts"
import style0 from "./pelletsverbrauch.vue?vue&type=style&index=0&id=b2d30ea6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d30ea6",
  null
  
)

export default component.exports